(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@makolab/library-react/dist/jssConfig"] = factory();
	else
		root["@makolab/library-react/dist/jssConfig"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/project_fcn_library-react/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 370);
/******/ })
/************************************************************************/
/******/ ({

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("@makolab/library-react/dist/utils");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/styles");

/***/ }),

/***/ 370:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "generateClassName", function() { return generateClassName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jss", function() { return jss; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jss__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jss_extend__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jss_extend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jss_extend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__commons_utils__);
// http://cssinjs.org/
// https://material-ui.com/customization/css-in-js/
var generateClassName=Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_styles__["createGenerateClassName"])({productionPrefix:'mlb-'+Object(__WEBPACK_IMPORTED_MODULE_3__commons_utils__["shortRandomId"])()+'-'});var jss=Object(__WEBPACK_IMPORTED_MODULE_1_jss__["create"])(Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_styles__["jssPreset"])()).use(__WEBPACK_IMPORTED_MODULE_2_jss_extend___default()());

/***/ }),

/***/ 371:
/***/ (function(module, exports) {

module.exports = require("jss");

/***/ }),

/***/ 372:
/***/ (function(module, exports) {

module.exports = require("jss-extend");

/***/ })

/******/ });
});
//# sourceMappingURL=jssConfig.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@makolab/library-react/dist/jssConfig.js
// module id = 639
// module chunks = 0